/* EAR PLAN — gentle appearance on scroll. Adds .ep-motion to <html> only when IntersectionObserver exists and the visitor
   has not asked for reduced motion; without this file (or JavaScript) everything is simply visible. */
(function () {
  if (!('IntersectionObserver' in window) || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
  var els = [].slice.call(document.querySelectorAll('[data-reveal]'));
  if (!els.length) return;
  document.documentElement.classList.add('ep-motion');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
  els.forEach(function (el, i) { el.style.setProperty('--ep-d', ((i % 4) * 90) + 'ms'); io.observe(el); });
  // never leave content hidden if the observer cannot fire (print, hidden tabs, very tall elements)
  window.setTimeout(function () { els.forEach(function (el) { el.classList.add('is-in'); }); }, 4000);
})();
